// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608310734/js/" + chunkId + "." + {"44":"d4768461","225":"5047736a","481":"241d9a63","486":"0d283c35","770":"71128d2f"}[chunkId] + ".0.9838291739274717.chunk.js";
};